<div id="notfound">
  <div class="notfound">
    <div class="notfound-412">
      <i class="fas fa-user-lock fa-8x"></i> 
    </div>
    <p class="heading">Sorry, you don't have the access to manage this page.</p>
  </div>
</div>